export default __webpack_public_path__ + "static/thumb-bpress-xl-3c293e095c76ff725611980f3fd51616.jpg";